import React  from "react";
import Iframe from 'react-iframe';
import CallTrackApi from "../Activity_Track/CallTrackApi";
  
function Fdcalculator() {
    

    function iframe() {
        return {
            __html: '<iframe src="fd-calculator.html" width="100%" height="650px" style="border:0; overflow:hidden"></iframe>'
        }
    }
    CallTrackApi("FD Calculator",window.location.href);
    return (
        <>
             <div>
                <div dangerouslySetInnerHTML={iframe()} />
            </div>        
        </>
    );
}
export default Fdcalculator;
